import { loginMock } from './mock/login'
export default [...loginMock]
